import {
    getWithdrawalPageListApi,
    updateWithdrawalRejectApi,
    updateWithdrawalPassApi,
    queryPaymentStatus, queryZjyzBalance
} from "@/api/WithdrawalApplicationApi";
import sd from "silly-datetime";

export const mixins = {
    data() {
        return {
            tableData: [],
            listParams: {
                current: 1,
                size: 10,
                name: "",
                type: "1",
                startTime: '',
                endTime: '',
                status: "",
                userId: ""
            },
            tableDataTotal: 0,
            balance: '',
            options: [
                {
                    value: '0',
                    label: '待审核'
                }, {
                    value: '1',
                    label: '已打款'
                }, {
                    value: '2',
                    label: '已驳回'
                }, {
                    value: '3',
                    label: '打款中'
                }, {
                    value: '4',
                    label: '打款失败'
                }],
            dateValue: "",
            orders: [],
            withdrawVisible: false,
            showRejectVisible: false,
            rejectId: null,
            rejectReason: ""
        }
    },
    methods: {
        openOrders(item) {
            this.orders = JSON.parse(item)
            this.withdrawVisible = true

        },
        async getWithdrawalPageList() {
            if (this.listParams.type == 1) {
                const res = await queryZjyzBalance();
                this.balance = res.data;
            }
            if (this.dateValue) {
                this.listParams.startTime = sd.format(this.dateValue[0], 'YYYY-MM-DD HH:mm:ss')
                this.listParams.endTime = sd.format(this.dateValue[1], 'YYYY-MM-DD HH:mm:ss')
            }

            let {data} = await getWithdrawalPageListApi(this.listParams)
            this.tableData = data.rows
            this.tableDataTotal = data.total
        },
        handleSizeChange(val) {
            this.listParams.size = val
            this.getWithdrawalPageList()
        },
        handleCurrentChange(val) {
            this.listParams.current = val
            this.getWithdrawalPageList()
        },
        clearParams() {
            this.listParams = {
                current: 1,
                size: 10,
                name: "",
                type: "",
                startTime: '',
                endTime: '',
                status: "",
                userId: ""
            }
        },
        async pass(id) {
            this.$confirm('确定已经线下公对公打款了吗？', '提示', {
                confirmButtonText: '确定',
                type: 'warning'
            }).then(async () => {
                await updateWithdrawalPassApi({id: id})
                this.$message.success("审核成功")
                this.getWithdrawalPageList()
            })
        },
        async reject() {
            await updateWithdrawalRejectApi({id: this.rejectId, remark: this.rejectReason})
            this.$message.success("审核成功")
            this.getWithdrawalPageList()
            this.closeRejectDialog();
        },
        showReject(id) {
            this.showRejectVisible = true;
            this.rejectId = id;
        },
        closeRejectDialog() {
            this.showRejectVisible = false;
            this.rejectId = "";
            this.rejectReason = "";
        },
        async searchResult(id) {
            await queryPaymentStatus({id: id});
            this.getWithdrawalPageList()
        }
    },
    created() {
        this.getWithdrawalPageList()
    }
}
